export const updateCourse = (payload?: any) => ({
    type: "@saga/UPDATE_COURSE",
    payload
});

